import axiosClient from "./axiosClient.js";
import ROUTES from "../constants/routes.js";

const B2b = {
  getWallet() {
    return axiosClient.get(ROUTES.WALLET);
  },

  getPackages() {
    return axiosClient.get(ROUTES.PACKAGES);
  },

  buyPackage(packageId, paymentPayload) {
    return axiosClient.post(ROUTES.CREATE_PAYMENT, {
      package_id: packageId,
      ...paymentPayload
    });
  },

  createCompany(companyPayload, userPayload) {
    return axiosClient.post(ROUTES.CREATE_COMPANY, {
      company: companyPayload,
      user: userPayload
    });
  }
};

export default B2b;
